/* eslint-disable max-len */
export default {
  lang: 'German',
  homeScreen: {
    title: 'Großartiges entdecken',
    stayConnected: 'In Verbindung bleiben',
    comingSoon: 'In Kürze verfügbar',
    messages: 'Nachrichten',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Schauen wir mal, ob wir in unserem System ein Profil für Sie finden können.',
      homeTitleSub:
        'Geben Sie die E-Mail-Adresse ein, die Sie normalerweise für die Anmeldung bei Schulungsprogrammen verwenden.',
      noAccount:
        'Kein Konto gefunden ({email}), bitte versuchen Sie es mit einer anderen E-Mail oder erstellen Sie jetzt ein Konto.',
      continueButton: 'Weiter',
      success:
        'Sie haben Ihr Konto erfolgreich aktualisiert! Sie werden in Kürze auf die Startseite weitergeleitet.',
      successNewAccount:
        'Um Ihre Anmeldung abzuschließen, erhalten Sie eine Bestätigungs-E-Mail, um Ihr Konto zu verifizieren.',
      loginButton: 'Anmeldung',
      matchFound:
        'Wir haben eine Übereinstimmung gefunden. Bitte geben Sie Ihr Passwort ein, um fortzufahren.',
      magicLink: 'Melden Sie sich über einen Link in Ihrer E-Mail an:',
      magicLinkButton: 'Magic Link anfordern',
      magicLinkTitle:
        'Lassen Sie sich einen direkten Link an Ihre E-Mail schicken, mit dem Sie sich sofort anmelden können.',
      otherEmailButton: 'Einreichen',
      title:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      titleIndustry:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      register: 'Ein Konto erstellen',
      agent: 'Reiseberater',
      visitor: 'Industrie Besucher',
      step1: 'Schritt 1: Art des Nutzers',
      step2: 'Schritt 2: Ein Konto erstellen',
      step3: 'Schritt 3: Erstellen Sie Ihr Profil',
      marketingOptIn:
        'Sind Sie sicher, dass Sie nicht daran interessiert sind, mit dem Travel Trade Team dieses Programms in Verbindung zu bleiben?',
      optIn: 'Ja, ich bin interessiert',
      optOut: 'Nicht Interessiert',
      step2Sub1: 'Erzählen Sie uns von sich selbst',
      step2Sub2: 'Erzählen Sie uns von Ihrem Unternehmen',
      privacyHead: 'KOMMUNIKATIONSPRÄFERENZEN',
      privacySub:
        'Kreuzen Sie die unten stehenden Kästchen an, um sicherzustellen, dass Sie wichtige Mitteilungen vom Reisebüroteam des Anbieters (Produktaktualisierungen und -ankündigungen, Prämien, Incentives, FAMs usw.) sowie Netzwerk- und Verkaufsförderungsinitiativen von TravPRO Mobile erhalten.',
      privacy:
        'Wir schützen Ihre Privatsphäre und verkaufen, missbrauchen oder betrügen niemals Ihr Vertrauen.',
      store:
        'Laden Sie dieses Programm ganz einfach in Ihrem App-Store herunter:',
      powered: 'ANGETRIEBEN DURCH',
      toastMessage: {
        forgotSuccess:
          'Wir haben Ihnen den Link zum Zurücksetzen Ihres Passworts per E-Mail geschickt! Sie werden in 10 Sekunden zur Login-Seite weitergeleitet.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warten Sie, wir melden Sie gerade an.',
        magicLinkError:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten keinen gültigen Token finden, bitte melden Sie sich an oder fordern Sie einen neuen magischen Link an.Wenn dieses Problem weiterhin besteht, kontaktieren Sie uns bitte unter: info@travpromobile.com.',
        magicLinkError2:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an.Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkSuccess:
          'Prüfen Sie Ihre E-Mail an {email}.Sie enthält einen magischen Link, mit dem du dich anmelden kannst.',
        magicLinkErrorWait:
          'Bitte warten Sie 5 Minuten zwischen den Anfragen nach magischen Links.',
        emailNotFoundError:
          'Die von Ihnen eingegebene E-Mail-Adresse kann in unseren Unterlagen nicht gefunden werden. Bitte prüfen Sie auf Schreibfehler oder erstellen Sie ein Konto.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode nicht gefunden, versuchen Sie es erneut',
        zipCodeOnlyNumbers: 'ZipCode kann nur Zahlen enthalten',
        password: 'Bitte geben Sie ein Passwort ein',
        passwordNotMatching:
          'Die von Ihnen eingegebenen Passwörter stimmen nicht überein',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        emailExists:
          'Diese E-Mail Adresse existiert bereits oder ist ungültig. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse oder melden Sie sich bei Ihrem Konto an.',
        fillInAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
        fillInEmail: 'Bitte geben Sie Ihre E-Mail-Adresse an.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy:
          'Sie haben Ihr Passwort vergessen und möchten es ändern? ',
        forgotSubCopy2:
          'Möchten Sie das Passwort ganz umgehen? Wir schicken Ihnen eine E-Mail mit einem magischen Link, der Sie automatisch beim Programm anmeldet.',
        city: 'Stadt',
        companyName: 'Name des Unternehmens',
        role: 'Ihre Rolle',
        description:
          'Was beschreibt das Geschäft Ihres Unternehmens am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort wählen (mindestens 8 Zeichen)',
        passwordConfirm: 'Bestätigen Sie Ihr Passwort',
        firstName: 'Vorname (gegeben)',
        lastName: 'Nachname (Familie)',
        agency: 'Name Ihrer Agentur',
        title: 'Ihre Rolle (Wählen Sie eine aus)',
        company: 'Name des Unternehmens',
        select: 'Wählen Sie unten eine Option',
        state: 'Staat',
        province: 'Bundesland/Region/Staat',
        zipCode: 'Postleitzahl',
        postalCode: 'Postleitzahl',
        affiliate: 'Welcher Gruppe gehören Sie in erster Linie an?',
        hostAgency: 'Ihre Aufnahmeagentur?',
        executive: 'Exekutive',
        management: 'Verwaltung',
        marketing: 'Marketing',
        sales: 'Vertrieb',
        coordinator: 'Koordinator',
        opt: 'Bleiben Sie mit dem Team dieses Programms in Verbindung und erhalten Sie aktuelle Informationen.',
        optMarketing:
          'Bleiben Sie mit TravPRO in Verbindung, wenn es um ähnliche Programme und Veranstaltungen geht.',
        retail: 'Einzelhandelsgeschäft Front',
        home: 'Home-Based Agent',
        independent: 'Unabhängiger Auftragnehmer',
        host: 'Gastgeber-Agentur',
        call: 'Call Center oder Web-basierte Agentur',
        other: 'Andere',
        describes:
          'Was beschreibt Sie und die Tätigkeit Ihrer Agentur am besten?',
      },
    },
    title: 'Schulung für Reisefachleute und Verkaufsförderungsprogramm',
    forgot: 'Passwort vergessen?',
    forgotCopy:
      'Bitte geben Sie die E-Mail-Adresse an, die Sie bei der Anmeldung für Ihr Finland Travel PRO-Konto verwendet haben. Wir senden Ihnen eine E-Mail, mit der Sie Ihr Passwort zurücksetzen können.',
    country: 'Land / Region *',
    select: 'Bitte wählen Sie unten eine Option aus',
    theme: 'Welches PRODUKTTHEMA verkaufen Sie hauptsächlich? *',
    type: 'Welches PRODUKTTHEMA verkaufen Sie hauptsächlich? *',
    businessType: 'Art des Geschäfts *',
    welcome: {
      headerTop: 'Willkommen zu',
      headerBottom: 'Finland Travel Pro',
    },
    sellingPoints: {
      0: 'Lernen, bewerben und verkaufen – egal wo',
      1: 'Multimediale Schulung auf allen Endgeräten',
      2: 'Abschlusszertifikat',
      3: 'Fertige Verkaufspräsentationen',
      4: 'Werbematerialien mit hoher Wirkung',
      5: 'Insider-Tipps & Aktionen',
      6: 'Produktverzeichnis in Echtzeit',
      7: 'Aktuelle Neuigkeiten und Updates',
    },
    emailPrompt:
      'Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um zu bestätigen, dass Sie ein Reiseprofi sind.',
    tAndC: {
      agree: 'Indem Sie fortfahren, stimmen Sie unseren zu',
      privacyPolicy: ' Datenschutz-Bestimmungen',
      and: ' und ',
      termsConditions: 'Geschäftsbedingungen zu',
    },
    fields: {
      agency: 'Unternehmen',
      email: 'E-Mail *',
      password: 'Passwort *',
      passwordConfirm: 'Bestätigen Sie Ihr Passwort *',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      city: 'Stadt *',
      agencyName: 'Unternehmensname *',
      stateProvince: 'Staat/Provinz',
      required: 'Erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'In Kontakt bleiben: Ja, ich möchte Mitteilungen von Finland Travel Pro erhalten, um über Neuigkeiten, Veranstaltungen, Incentives, Famtrips und mehr auf dem Laufenden zu bleiben!',
      forgot:
        'Haben Sie Ihr Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
    },
    noAgent: {
      noAgentButton: 'Ich bin kein Berater',
      title: 'Vielen Dank für Ihr Interesse an Finland Travel Pro.',
      messageWeb:
        'Der Inhalt dieser Website richtet sich ausschließlich an Reisefachleute. Um mehr über Finnland zu erfahren, besuchen Sie bitte:',
      messageMobile:
        'Die Inhalte dieser App sind ausschließlich für Reiseprofis bestimmt, klicken Sie auf „Weiter“, um eine Vorschau zu erhalten.',
      continue: 'Fortsetzen',
      visitWebsite: 'Besuchen Sie die Website',
    },
    newUser: 'Neuer Nutzer',
    register: 'Registrieren',
    registered: 'Diese E-Mail ist bereits registriert',
  },
  welcomeScreen: {
    title: 'Willkommen bei Finland Travel Pro',
    helloUser: 'Hallo {{name}}',
    hello: 'Hallo,',
    fromAgency: 'von {{agency}}',
    notUser: 'Nicht {{name}}?',
    introOnline:
      'Trainieren Sie sofort online oder laden Sie die Inhalte im Voraus herunter, so dass sie immer offline verfügbar sind!',
    introOffline:
      'Sie haben bereits die neueste Version geladen. Beginnen Sie jederzeit und überall mit dem Training oder fangen Sie gleich an zu verkaufen!',
    startTraining: 'beginne zu lernen',
    continueTraining: 'weiter lernen',
    graduated: 'Herzlichen Glückwunsch!',
    downloader: {
      preload: 'Im Voraus herunterladen',
      stop: 'aufhören',
      init: 'Es geht gleich los…',
      lastUpdate: 'Letzte Aktualisierung:',
    },
  },
  directory: {
    city: 'Nach Stadt filtern',
    search: 'Suche nach einem Produkt',
    product: 'Nach Produkttyp filtern',
    reset: 'Filter zurücksetzen >',
    category: 'Nach Kategorie filtern',
    season: 'Nach Saison filtern',
    noResults: 'Keine Ergebnisse gefunden',
    target: 'Nach Zielgruppe filtern',
    additional: 'Zusätzliche Filter',
    sustainable: 'Nachhaltiges Reisen Finnland',
    accessible: 'Zugänglich',
    results: 'Ergebnisse',
  },
  contactView: {
    regions: {
      europe: 'Europa',
      northAmerica: 'Nordamerika',
      asiaPacific: 'Asien Pazifik',
      fcb: 'FCB - Finland Convention Bureau',
    },
    jobTitles: {
      salesMarketing: 'Manager für Verkauf und Vertrieb',
      directorVisitFinland: 'Regisseur von Visit Finland (Dach & Benelux)',
      specialist: 'Spezialist',
      accountManager: 'Account Manager',
      advisor: 'Berater',
      headVisitFinlandNorthAmerica: 'Leiter von Visit Finland Nordamerika',
      managerBusinessEvents: 'Manager, Business Events',
      seniorBusinessEvents: 'Senior Spezialist für Business-Events',
    },
    countries: {
      gbIreland: 'Großbritannien & Irland',
      spainItaly: 'Spanien & Italien',
      france: 'Frankreich',
      westEurope:
        'Deutschland, Österreich, Schweiz, Belgien, Niederlande, Luxemburg',
      benelux: 'Dach, Benelux',
      rusiaCISBaltics: 'Baltikum',
      rusiaCIS: 'CIS',
      northAmerica: 'Nordamerika',
      japan: 'Japan',
      chinaSEAsia: 'Großchina & Südostasien',
      southKorea: 'Südkorea',
      india: 'Indien & UAE',
      australia: 'Australien',
    },
  },
  trainingScreens: {
    start: 'Beginnen',
    continue: 'Weiter',
    review: 'Überprüfen',
    restart: 'Neu starten',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number}% abgeschlossen',
    unlock: 'Das Kapitel wird bei Abschluss des Kapitels X freigeschaltet',
    unlockSubtitle:
      'Absolvieren Sie die Kapitel und weitere Kapitel werden freigeschaltet.',
    allUnlocked: 'Sie haben alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Weiter',
    endReached: 'Sie sind am Ende angekommen',
    retainEnd:
      'Verwenden Sie die obere Leiste, um in diesem Kapitel zu navigieren oder drücken Sie die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Sehen, hören und mehr lesen',
    trouble:
      'Bitte lesen Sie den Inhalt der vorherigen Seite(n) noch einmal und versuchen Sie es erneut.',
    confirm: 'Bestätigen Sie Ihre Antwort',
    choose: 'Bitte eine Antwort auswählen',
    skip: 'Zurück >',
    viewAllTitle: 'Lerntipp',
    viewAll:
      'Um zur nächsten Seite zu gelangen, klicken Sie bitte auf die Symbole, um die zusätzlichen Inhalte anzuzeigen. Wir haben Videos, Karten und andere hilfreiche Informationen zusammengestellt, damit Sie zum Profi werden.',
    fillBlanks: 'Füllen Sie die Lücke(n) aus:',
    next: 'Nächste Frage',
    retry: 'Nochmal versuchen',
    fastTrackText: {
      success:
        'Herzlichen Glückwunsch, Sie haben den Expresskurs bestanden und den Rest des Kurses freigeschaltet!',
      failed:
        'Leider haben Sie den Expresskurs nicht bestanden. Lernen Sie noch ein wenig, um zu Ihrem Diplom zu gelangen!',
    },
    fastTrack: 'Werden Sie ein Finland Travel Pro!',
    fastTrackExplanation:
      'Nehmen Sie einfach am Quiz auf den folgenden Seiten teil und gewinnen Sie einen FAM to Switzerland! Alle Antworten auf die Quizfragen finden Sie auf folgenden Wegen: Die Inhalte, die Sie in den Modulen Rail Europe und Switzerland gelernt haben und auf den folgenden Webseiten : Sehen Sie sich diese Ressourcen genau an, bevor Sie am Quiz teilnehmen! Nur diejenigen mit den höchsten Punktzahlen haben die Chance, zum FAM eingeladen zu werden.',
    fastTrackButton:
      'Klicken Sie hier, um am Finland Travel Pro-Quiz teilzunehmen',
    grading: 'Ihre Endnote ist: {grade}%',
  },
  nav: {
    home: 'Home',
    train: 'Üben',
    learn: 'Lernen',
    retain: 'Behalten',
    directory: 'Verzeichnis',
    showRoom: 'Showcases',
    showcases: 'Showcases',
    promote: 'Bewerben',
    sell: 'Verkaufen',
    info: 'Info',
    rewards: 'Prämien',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Kontakt',
    reportCard: 'Zertifikat ansehen',
    accountSettings: 'Kontoeinstellungen',
    messages: 'Nachrichten',
    search: 'Suchen',
  },
  contentHeaders: {
    train: 'Lernen',
    retain: 'Behalten',
    subapps: 'Partnermodule',
    maintrainings: 'Grundlagen',
    subtrainings: 'Spezialisierungsmodule',
  },
  pageDescriptions: {
    train: 'Sich informieren, sich engagieren und zum Experten werden',
    showroom: '',
    retain:
      'Der Ort des gebündelten Wissens: Nutzen Sie diesen Bereich, um eine Produktfrage fachkundig zu beantworten oder eine Verkaufspräsentation zu halten – jederzeit, überall und von jedem Endgerät aus.',
    promote:
      'Teilen Sie diese Artikel, um Interesse zu wecken und ein Gespräch mit Kunden und Interessenten zu beginnen.',
    sell: 'Beantworten Sie Kundenfragen und schließen Sie den Verkauf wie ein Profi ab – mit umfassenden Ressourcen und gezielter Vertriebsunterstützung.',
    favorites: 'Gemerkte Inhalte ansehen',
    search: 'Alle Inhalte ansehen',
    subapps: '',
    maintrainings:
      'Absolvieren Sie diese wichtigen Module, um Ihr Zertifikat zu erhalten.',
    subtrainings: 'Informieren Sie sich über spezielle Produkte',
  },
  directoryFilters: {
    cities: 'Nach Stadt filtern',
    search: 'Nach einem Produkt suchen',
    type: 'Nach Produkttyp filtern',
    reset: 'Filter zurücksetzen >',
    tags: 'Nach Tags filtern',
    months: 'Nach Saison filtern',
    noResults: 'Keine Ergebnisse gefunden',
    targetGroups: 'Nach Zielgruppe filtern',
    additional: 'Zusätzliche Filter:',
    sustainable: 'Nachhaltiges Reisen Finnland',
    accessible: 'Barrierefrei',
    results: 'Ergebnisse',
  },
  general: {
    viewBadge: 'Ansicht',
    viewBadge2: 'Abzeichen',
    back: 'Zurück',
    next: 'Nächste Seite',
    yes: 'Ja',
    no: 'Nein',
    previous: 'Zurück',
    page: 'Seite',
    search: 'Suche',
    logIn: 'Einloggen',
    logOut: 'Ausloggen',
    viewItem: '{Typ} anzeigen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Es wurden keine Ergebnisse gefunden für: {{query}}',
    noFavorites: 'Sie haben noch keine Favoriten.',
    noMessages: 'Sie haben noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für: {{query}}',
    showAll: 'Alles anzeigen',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'Bereits vorhanden',
    pageNotFound: '404 Seite nicht gefunden',
    oops: 'Ups...',
    overview: 'Zurück zur Übersicht',
    complete: 'Fortsetzen',
    courseComplete: 'Kapitel abgeschlossen',
    chapterComplete: 'Kapitel abgeschlossen',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Webseite',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie an den Ziffern, um Ihre Antwort einzugeben',
    fitb: 'Füllen Sie die Lücke(n) aus',
    flip: 'Ändern Sie die Zahl entsprechend Ihrer Antwort',
    multipleChoice: 'Wählen Sie die richtige(n) Antwort(en) aus',
    slider: 'Wählen Sie die richtige Antwort mit dem Schieberegler aus',
    map: 'Beantworten Sie die Frage, indem Sie auf den richtigen Ort auf der Karte tippen',
    dropdown: 'Wählen Sie...',
    true: 'Richtig',
    false: 'Falsch',
  },
  reportCard: {
    download: 'Herunterladen',
    email: 'E-Mail ',
    print: 'Drucken',
  },
  cookies: {
    consent: 'Zustimmen',
    optout: 'Ablehnen',
    settings: 'Datenschutzeinstellungen',
    message:
      'Sie haben uns nichts über Ihre Datenschutzpräferenzen mitgeteilt. Gerne möchten wir Ihnen die beste Erfahrung bieten.',
    disabled: 'Anscheinend haben Sie die Nutzung von Cookies deaktiviert.',
    use: '{{appName}} erfordert die Nutzung von Cookies, um Ihnen das beste Erlebnis zu bieten.',
    details: 'Wofür werden die Cookies verwendet?',
    enable: 'Sehen Sie {{hier}}, wie Sie Ihre Cookies aktivieren.',
    here: 'Hier',
  },
  notLoggedIn: {
    super: 'Sie sind nicht eingeloggt',
    title: 'Sie müssen eingeloggt sein, um diesen Inhalt zu sehen',
    guest: 'Gast',
  },
  demo: {
    message:
      'Diese Website ist eine Demoversion des Endprodukts. Dieses befindet sich aktuell in der Entwicklung und ist kein fertiges Produkt.',
    consent: 'Verstanden!',
  },
  share: {
    header: 'Teilen Sie diese Ressource in Ihren bevorzugten sozialen Medien!',
    download: 'Herunterladen',
  },
  sharing: {
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
    emailSubject: 'Eine Finnland-Ressource',
    emailCopy:
      'Ich hoffe, Ihnen gefällt diese Finnland-Ressource. Bitte kontaktieren Sie uns und lassen Sie uns mit der Planung Ihrer nächsten Reise beginnen!',
    videoEmailSubject: 'Viel Spaß mit diesem Finnland-Video',
    videoEmailCopy:
      'Ich hoffe, dir gefällt dieses Finnland-Video. Bitte kontaktieren Sie uns und lassen Sie uns mit der Planung Ihrer nächsten Reise beginnen!',
    imageEmailSubject: 'Genießen Sie dieses Finnland-Bild',
    imageEmailCopy:
      'Ich hoffe, Sie genießen dieses Finnland-Bild. Bitte kontaktieren Sie uns und lassen Sie uns mit der Planung Ihrer nächsten Reise beginnen!',
    twitterCopy: 'Entdecken Sie die großen Dinge in Finnland',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header:
      'Anscheinend versuchen Sie, von einem Mobilgerät aus auf die {appName}-App zuzugreifen',
    body: 'Um diese App herunterzuladen, besuchen Sie einfach Ihren App-Store und suchen Sie nach {appName} oder klicken Sie auf eine der Schaltflächen unten',
    benefits: {
      1: 'Lernen, bewerben und verkaufen – egal wo',
      2: 'Multimediale Schulung auf allen Endgeräten',
      3: 'Abschlusszertifikat',
      4: 'Fertige Verkaufspräsentationen',
      5: 'Werbematerialien mit hoher Wirkung',
      6: 'Produktverzeichnis in Echtzeit',
      7: 'Aktuelle Neuigkeiten und Updates',
      header: 'Dadurch erhalten Sie:',
    },
  },
  custom: {
    splitUsers: 'Ich bin ein ...',
    brandAmbassador: 'Markenbotschafter',
    travelPro: 'Reiseprofi',
  },
  submit: 'Absenden',
  back: 'Zurück',
  close: 'Schließen',
  search: {
    pages: 'Seiten',
    resources: 'Ressourcen',
  },
};
